import type { AssetCategory } from '../types';

export type AssetCategoryOption = {
  value: AssetCategory;
  label: string;
};

export const ASSET_CATEGORY_OPTIONS: AssetCategoryOption[] = [
  { value: 'real_estate', label: 'Real estate' },
  { value: 'cash', label: 'Cash' },
  { value: 'securities', label: 'Securities' },
  { value: 'private_equity', label: 'Private equity' },
  { value: 'collectibles', label: 'Collectibles' },
  { value: 'vehicle', label: 'Vehicle' },
  { value: 'business_equity', label: 'Business equity' },
  { value: 'other_asset', label: 'Other asset' },
];

export const LIABILITY_CATEGORY_OPTIONS: AssetCategoryOption[] = [
  { value: 'mortgage', label: 'Mortgage' },
  { value: 'loan', label: 'Loan' },
  { value: 'credit_line', label: 'Credit line' },
  { value: 'tax', label: 'Tax' },
  { value: 'other_liability', label: 'Other liability' },
];

const CATEGORY_LABELS: Record<AssetCategory, string> = {
  real_estate: 'Real estate',
  cash: 'Cash',
  securities: 'Securities',
  private_equity: 'Private equity',
  collectibles: 'Collectibles',
  vehicle: 'Vehicle',
  business_equity: 'Business equity',
  other_asset: 'Other asset',
  mortgage: 'Mortgage',
  loan: 'Loan',
  credit_line: 'Credit line',
  tax: 'Tax',
  other_liability: 'Other liability',
};

export function categoryLabel(category: AssetCategory): string {
  return CATEGORY_LABELS[category] ?? category;
}
